var irreducible = require('./irreducible');

module.exports = irreducible('Date', function (x) { return x instanceof Date; });



//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/Date.js
// module id = 410
// module chunks = 0